import * as React from 'react';
import * as classNames from "classnames";
import { withTheme } from "../../common/withTheme";

interface INavMenuProps {
    theme?: string;
}

interface INavMenuActions {

}

type NavMenuProps = INavMenuProps & INavMenuActions;

interface IMenuState {
    showMenu: boolean;
}

class NavMenu extends React.Component<NavMenuProps, any> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showMenu: false
        }

        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu() {
        this.setState({ showMenu: !this.state.showMenu });
    }

    render() {
        return <div className={classNames(this.props.theme, "text-center text-nowrap")}>
            <nav className={classNames(this.props.theme, "navbar navbar-expand-lg navbar-light bg-light")}>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation" onClick={this.toggleMenu}>
                    Menu
                </button>
                <div className={classNames("collapse navbar-collapse justify-content-center", { "show": this.state.showMenu })}>
                    <div className="navbar-nav text-uppercase container justify-content-center flex-wrap">
                        {this.props.children}
                    </div>
                </div>
            </nav>
        </div>;
    }
}

export default withTheme<NavMenuProps>(NavMenu);